<template>
		<b-container fluid class="margin-top-header">
			<b-row>
				<b-col cols="12">
					<b-link class="text-macal" to="/autos/vende/cotizar">
						<b><font-awesome-icon :icon="['fal', 'chevron-left']" />VOLVER</b>
					</b-link>
				</b-col>
				<b-col cols="12" md="8" offset-md="2">
					<b-row>
						<b-col cols="12" class="bg-grey text-center p-4">
							<h4>{{data.brandText}} {{data.modelText}} {{data.versionText}}</h4>
							<h4>{{data.yearText}} | {{data.kmText}} KM</h4>
							<hr />
							<h1><b class="text-macal">$ {{car.offer}}</b></h1>
						</b-col>
						<b-col cols="12" class="bg-grey text-center mt-4 p-4">
							<h4>¡Únicos con <b>Doble Pago</b>!</h4>
							<div>
								Solo Macal te premia con un pago extra, descubre como <b><b-link v-b-toggle.accordion-1 class="text-macal">aquí</b-link></b>
								<b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
									<hr />
									<b-table-simple borderless>
										<b-tr>
											<b-td style="width: 10%; border-right: 2px">
												<h1 class="text-grey border-right-macal">01</h1>
											</b-td>
											<b-td class="text-left">
												Tomamos tu auto<br />
												<small>Cotiza tu <b>precio online</b>, agenda tu inspección y listo.</small>
											</b-td>
										</b-tr>
										<b-tr>
											<b-td style="width: 10%;">
												<h1 class="text-grey border-right-macal">02</h1>
											</b-td>
											<b-td class="text-left">
												Vendemos tu auto<br />
												<small>El auto será rematado <b>en los próximos 15 días</b>.</small>
											</b-td>
										</b-tr>
										<b-tr>
											<b-td style="width: 10%;">
												<h1 class="text-grey border-right-macal">03</h1>
											</b-td>
											<b-td class="text-left">
												Pago Extra: te damos 50% del excedente alcanzado<br />
												<small>Si precio de <b>venta supera el monto</b> que te pagamos inicialmente.</small>
											</b-td>
										</b-tr>
									</b-table-simple>
								</b-collapse>
							</div>
						</b-col>
						<b-col cols="12" class="bg-grey text-center mt-4 p-4">
							<h2><b>¡Listo!</b></h2>
							<p>Considera estos importantes puntos</p>
							<hr />
							<ul class="macal-ul text-justify" style="display: inline-block;">
								<li>Sólo puede entregar el vehículo el dueño del auto.</li>
								<li>Si tienes dudas contáctanos a <a href="mailto:particulares@macal.cl" > particulares@macal.cl</a>.</li>
								<li>Tu regreso asegurado en cabify.</li>
								<li>Sin notarías, nos encargamos de todos los trámites</li>
							</ul>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-container>
</template>

<script>

export default {
	name: 'v-sell-modal',
	components: {},
	props: {
		price: String,
		data: {default: null},
		car: {default: null},
		reservation: {default: null},
	},
	data (){
		return{}
	},
	beforeMount() {
		this.hasReservation();
	},
	methods: {
		hasReservation(){
			if(this.reservation == null){
				this.$router.push({ name: 'vehicles-sell-quote' });
			}
		},
	},
	watch: {}
}	
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	#modal-sell___BV_modal_outer_{
		z-index: 1060 !important;
	}
	#modal-sell .multiselect-sm {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
	}
	#modal-sell .multiselect-sm .multiselect__tags {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
		padding: 0.25rem 0.5rem !important;
	}
	#modal-sell .multiselect-sm .multiselect__select {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		padding: 0.25rem 0.5rem !important;
	}
	.w-100 .vdp-datepicker__calendar{
		width: 100%;
	}
	.captcha-element>div>div{
		margin-left: auto;
		margin-right: auto;
	}
</style>